import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getIdToken } from '../../auth';
import { IRequests, IResult, IBusinessInformation, IRepositoryInformation, IPaging} from '../../types/Requests';
import { BASE_URL_ENDPOINT } from '../../config/env';

interface IState{
    paging: null | IPaging,
    result: IRequests[],
    resultx: IRequests[],
    results: IResult[] | null,
    error: null | any
}
const initialState: IState = {
    paging: null,
    result: [],
    resultx: [],
    results: null,
    error: null
}

// console.log("este es el token en el RequestSlice***:", token);
export const fetchRequestRepositorys = createAsyncThunk(
    'fetchRequestRepositorys',
    async (url:string = '${BASE_URL_ENDPOINT}/management-ctx/api/v2/repository-request',
    ) => {
        const token = getIdToken();
        const pull = await fetch(url,{headers: {
            method: 'GET',
            'Content-type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': `Bearer ${token}` 
            }})
            .then(response => response.json())
            .then(data => data)
            .catch(error => {
                console.log("error:",error);
                return error;
            });
            
        return pull
    }    
);
export const fetchRequestRepositorysById = createAsyncThunk(
    'fetchRequestRepositorysById',
    async (idAsString: string) => {
        const token = getIdToken();
        const data = await fetch(`${BASE_URL_ENDPOINT}/management-ctx/api/v2/repository-request/:id?id=${idAsString}`,{
            method: 'GET',
            headers: {
            'Content-type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': `Bearer ${token}`},
        })
            .then( response => response.json())
            .then(data => data)
            .catch(error => {
                console.log("error:",error);
                return error;
            })
         
        console.log("data request by id***:",data);
        return data
    }
);


export const patchRequestRepositoryById = createAsyncThunk(
    'patchRequestRepositoryById',
    async (id: string, data: object) => {
        const token = getIdToken();
        const response = await fetch(`${BASE_URL_ENDPOINT}/management-ctx/api/v2/repository-request/:id=${id}`,{
            method: 'PATCH',
            headers: {
            'Content-type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(data)
        })
        
            .then( response => response.json())
            .then(data => data)
            
            .catch(error => {
                console.log("error:",error);
                return error;
            })
         
        console.log("response***:",response);
        return response
    }
)

const RepositorysSlice = createSlice({
    name: "repositorysSlice",
    initialState,
    reducers: {

    },
    extraReducers(builder) {
        builder.addCase(
            fetchRequestRepositorys.fulfilled, (state, action) => {
                state.paging = action.payload.paging;
                console.log("state-paging:",state.paging);
                state.result = action.payload.result;
                console.log("state-result-request**:",state.result);
                state.results = action.payload.results;
                console.log("state-result-request-results**:",state.results);
                state.error = null;
            }
        );
        builder.addCase(
            fetchRequestRepositorys.rejected, (state, action) => {
                state.error = action.payload;
            }
        );
        builder.addCase(
            fetchRequestRepositorysById.fulfilled, (state, action) => {
                state.result = action.payload.resultx;
                console.log("state-result-request**:",state.resultx);
                
                state.error = null;
            }
        );
        builder.addCase(
            fetchRequestRepositorysById.rejected, (state, action) => {
                state.error = action.payload;
            }
        );
       
    },
});

export default RepositorysSlice.reducer;